const TARGET_MAX_SIZE = 2 * 1024 * 1024;

const encodeCanvas = (canvas, outputType, quality) => {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (!blob) return reject(new Error('Canvas toBlob thất bại'));
                resolve(blob);
            },
            outputType,
            quality,
        );
    });
};

export const resizeImage = (file, options = {}) => {
    if (!file.type.startsWith('image/')) return Promise.resolve(file);

    const {
        maxWidth = 2560,
        maxHeight = 2560,
        outputType = 'image/jpeg',
    } = options;

    return new Promise(async (resolve, reject) => {
        try {
            const img = new Image();
            const url = URL.createObjectURL(file);

            img.onload = async () => {
                URL.revokeObjectURL(url);

                let { width, height } = img;

                if (width > maxWidth || height > maxHeight) {
                    const ratio = Math.min(maxWidth / width, maxHeight / height);
                    width = Math.round(width * ratio);
                    height = Math.round(height * ratio);
                }

                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(img, 0, 0, width, height);

                let quality = 0.95;
                let blob = await encodeCanvas(canvas, outputType, quality);

                while (blob.size > TARGET_MAX_SIZE && quality > 0.5) {
                    quality = Math.round((quality - 0.05) * 100) / 100;
                    blob = await encodeCanvas(canvas, outputType, quality);
                }

                const resizedFile = new File([blob], file.name, {
                    type: outputType,
                    lastModified: Date.now(),
                });

                const finalFile = resizedFile.size < file.size ? resizedFile : file;

                resolve(finalFile);
            };

            img.onerror = reject;
            img.src = url;
        } catch (err) {
            reject(err);
        }
    });
};

export const resizeImages = (fileList, options = {}) => {
    return Promise.all(
        Array.from(fileList).map((file) => resizeImage(file, options))
    );
};